module.exports = __webpack_public_path__ + "img/sankaku_56_blue.806731af.png";